import {Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DebtsService} from "../../../models/debts/debts.service";

@Component({
    selector: 'select-statements-modal',
    templateUrl: 'template.html',
    styleUrls: ['style.css']
})

export class SelectStatementsModalComponent implements OnInit, AfterViewInit {
    
    public accountId: number;
    public reason: number;

    public reasons;

    constructor(
        public activeModal: NgbActiveModal,
        private debtsService: DebtsService) {

    }

    ngOnInit() {

    }

    ngAfterViewInit() {

    }

    goto(period: any = null) {
        let drop_time = (date: any) => {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        };
        let start_last_month = (date: any) => {
            drop_time(date);
            date.setDate(-1);
            date.setDate(1);
        };
        let start_next_month = (date: any) => {
            drop_time(date);
            date.setDate(1);
            date.setDate(32);
            date.setDate(1);
        };
        let start_last_year = (date: any) => {
            drop_time(date);
            date.setMonth(-1);
            date.setMonth(0)
            date.setDate(1);
        };
        let start_next_year = (date: any) => {
            drop_time(date);
            date.setMonth(12);
            date.setDate(1);
        };

        let result: any;
        if (period == 'm') {
            let t0: any = new Date();
            start_last_month(t0);
            start_next_month(t0);
            let t1: any = new Date(t0);
            start_next_month(t1);
            result = {
                'from': t0 * 1,
                'to': t1 * 1        
            };
        } else if (period == 'y') {
            let t0: any = new Date();
            start_last_year(t0);
            start_next_year(t0);
            var t1: any = new Date(t0);
            start_next_year(t1);
            result = {
                'from': t0 * 1,
                'to': t1 * 1        
            };
        } else {
            result = null;
        }

        this.activeModal.close(result);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/debt-account/select-statements/component.ts